// useSetSuccessorFileAccess.ts
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { SESSION_QUERY_KEY } from './CheckSessionHook'

type BackendResponse = {
  status: "success";
  data: { canViewFiles: boolean | number };
};

export type FileAccessPayload = {
  canViewFiles: boolean;
};

export const useSetSuccessorFileAccess = (
  options?: UseMutationOptions<{ canViewFiles: boolean }, any, FileAccessPayload>
) => {
  return useMutation<{ canViewFiles: boolean }, any, FileAccessPayload>({
    ...options,
    mutationKey: ["set-successor-file-access"],
    mutationFn: async ({ canViewFiles }) => {
      const res = await axiosInstance.post<BackendResponse>(
        "/successors/file-access",
        { canViewFiles }
      );
      return {
        canViewFiles: Boolean(res.data.data.canViewFiles), // 👈 tylko boolean
      };
    },
    onMutate: (variables) => {
      Toast({
        message: "Aktualizuję dostęp do plików…",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "set-successor-file-access",
      });

      if (options?.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: variables.canViewFiles
          ? "Udostępniono pliki Reliance"
          : "Wyłączono dostęp Reliance do plików.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "set-successor-file-access",
      });

      queryClient.invalidateQueries({ queryKey: ["successor-settings"] });
      queryClient.invalidateQueries({ queryKey: ["successors-list"] });

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["successor-settings"] });
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      Toast({
        message: "Błąd podczas aktualizacji dostępu do plików.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "set-successor-file-access",
      });

      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useSetSuccessorFileAccess;
